import FuturesEvidencePanel from './FuturesEvidencePanel'

export default function FuturesOrdersListView() {
  return (
    <FuturesEvidencePanel
      title="Futures Orders"
      accessLabel="Futures"
      accessTarget="frmFuturesMainSubFormFuturesOrder -> frmFuturesQryFuturesOrder"
      description="Futures order control list with Access New/Edit/Delete/Mass Upload actions. Full grid fields and validation must come from the order list/add forms before CRUD is wired."
      actions={['New', 'Edit', 'Delete', 'Mass Upload']}
      evidence={[
        'form_frmFuturesMainSubFormFuturesOrder.txt',
        'form_frmFuturesQryFuturesOrder.txt',
        'form_frmFuturesQryFuturesOrderAdd.txt',
        'form_frmFuturesQryFuturesOrderAddMany.txt',
        'query_FuturesQryFuturesOrder.txt',
      ]}
      notes={[
        'New suggests order_number with Suggest_IndexName("orders_futures") and defaults date to Now().',
        'Edit is blocked for spread-generated orders whose order_number starts with SP; those must be edited in Spreads.',
        'Delete soft-deletes public_orders_futures by order_number and refreshes the list.',
      ]}
    />
  )
}
